import { CollectionType } from '@/enums/collection-type';

export const RESPONSE_TYPES = [
	{
		type: 'new',
		collectionTypes: [CollectionType.NEW, CollectionType.PRICEDROPS, CollectionType.OFFERS],
	},
	{ type: 'popular', collectionTypes: [CollectionType.POPULAR, CollectionType.SEARCH, CollectionType.WATCHLIST] },
]
	.map(item => {
		return item.collectionTypes.map(collectionType => ({ [collectionType]: item.type }));
	})
	.reduce((root, item) => {
		root = root.concat(item);
		return root;
	}, [])
	.reduce((root, item) => {
		const key = Object.keys(item)[0] as CollectionType;
		root[key] = item[key] as 'new' | 'popular';
		return root;
	});
